import { CatalogItemType } from 'models'

export const transformCatalogItemType = (genre: number): string => {
  switch (genre) {
    case CatalogItemType.Film: {
      return 'Фильм'
    }
    case CatalogItemType.Serial: {
      return 'Сериал'
    }
    case CatalogItemType.Show: {
      return 'Шоу'
    }
    case CatalogItemType.KinoStories: {
      return 'КиноStories'
    }
    case CatalogItemType.Documentary: {
      return 'Документальный фильм'
    }
    case CatalogItemType.FeatureFilm: {
      return 'Художественный фильм'
    }
    default:
      return ''
  }
}
